/** Source: public/design-patterns.html F-2a. */
type LegalArticle = { heading: string; items: string[] }
export function Legal({ articles = [], revised }: { articles?: LegalArticle[]; revised?: string }) {
  return <div className="shell sec tight"><div className="legal">{articles.map((article, i) => <section key={`${article.heading}-${i}`}><h2>{article.heading}</h2><ol>{article.items.map((item) => <li key={item}>{item}</li>)}</ol></section>)}{revised && <p className="rev">{revised}</p>}</div></div>
}

